import React, { useMemo } from 'react';

import PrequalConsumerSearch from 'features/prequal/ConsumerSearch';
import { RouteComponentProps } from 'react-router';
import useWorkflow, { Step } from 'hooks/useWorkflow';
import { useTrackApplicationStart } from 'hooks/useAnalytics';
import CardSelector from 'features/CardSelector/CardSelector';

const PrequalConsumerSearchHome: React.FC<RouteComponentProps> = props => {
  const { steps } = useWorkflow();
  const startPageName =
    steps[0] === Step.CARD_SELECTOR ? 'card-selector' : undefined;
  useTrackApplicationStart(startPageName);

  const Component = useMemo(() => {
    switch (steps[0]) {
      case Step.CONSUMER_SEARCH:
        return PrequalConsumerSearch;
      case Step.CARD_SELECTOR:
        return CardSelector;
      default:
        throw new Error(`Unexpected start route ${steps[0]}`);
    }
  }, [steps]);

  return <Component {...props} />;
};

export default PrequalConsumerSearchHome;
